import React from 'react'
import {ToggleButton, ToggleButtonDefaults} from '../../inputs';

export default function DisableAutoPopulate(props) {
  const { onChange, checked } = props

  return (
    <ToggleButton checked={checked} onChange={onChange} label={'Disable Autopopulate'} margins={ToggleButtonDefaults.margins}/>
  )
}